import { EnvEnum } from "@/src/enums/common";

export const getEnv = (): EnvEnum =>
  (process.env.ENVIRONMENT as EnvEnum) || EnvEnum.DEV;

export const isBrowser = (): boolean => typeof window !== "undefined";

export const isServer = (): boolean => !isBrowser();
